module.exports = __webpack_public_path__ + "static/media/sound_11.2233d332.mp3";